import { render, staticRenderFns } from "./UnauthorizedPage.vue?vue&type=template&id=7c2aae56&"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports